var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewDcCinza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2291 10.3356H15.0098V13.0067H17.6808V14.7874H15.0098V17.4584H13.2291V14.7874H10.558V13.0067H13.2291V10.3356ZM7.88697 0.541748C11.8223 0.541748 15.0098 2.13548 15.0098 4.10315C15.0098 6.07083 11.8223 7.66456 7.88697 7.66456C3.95162 7.66456 0.76416 6.07083 0.76416 4.10315C0.76416 2.13548 3.95162 0.541748 7.88697 0.541748ZM0.76416 5.88385C0.76416 7.85153 3.95162 9.44526 7.88697 9.44526C11.8223 9.44526 15.0098 7.85153 15.0098 5.88385V8.62613L14.1194 8.55491C11.8134 8.55491 9.84574 10.0151 9.09784 12.0629L7.88697 12.1163C3.95162 12.1163 0.76416 10.5226 0.76416 8.55491V5.88385ZM0.76416 10.3356C0.76416 12.3033 3.95162 13.897 7.88697 13.897H8.77732C8.77732 14.8319 9.01771 15.7133 9.44508 16.479L7.88697 16.5681C3.95162 16.5681 0.76416 14.9743 0.76416 13.0067V10.3356Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDcCinza);
export default __webpack_public_path__ + "static/media/newDcCinza.5939775ed6359e5427ce7cfdec72e71b.svg";
export { ForwardRef as ReactComponent };